import { Component, OnInit, ViewChild } from '@angular/core';
import { FilterRequestEvaluated } from '../shared/filter-request-evaluated.model';
import { ReportsService } from '../shared/reports.service';
import { RequestsEvaluated } from '../shared/requests-evaluated.model';
import { ReportsComponent } from '../reports.component';

@Component({
  selector: 'app-requests-evaluated',
  templateUrl: './requests-evaluated.component.html',
  styleUrls: ['./requests-evaluated.component.scss']
})
export class RequestsEvaluatedComponent implements OnInit {

  requests: RequestsEvaluated[];
  enabledSpinner = false;
  @ViewChild(ReportsComponent) reportsComponent: ReportsComponent;

  constructor(private reportService: ReportsService) { }

  ngOnInit() {
    this.getListRequestsEvaluated(new FilterRequestEvaluated());
  }

  getListRequestsEvaluated(filterRequest: FilterRequestEvaluated) {
    filterRequest.evaluador = localStorage.getItem('cedula');
    this.reportService.getRequestEvaluated(filterRequest).subscribe(
      (result) => {
        if (result.data) {
            this.requests = result.data as RequestsEvaluated[];
            this.enabledSpinner = false;
        }
      }
    );
  }

  sendFilter(event: FilterRequestEvaluated) {
    this.enabledSpinner = true;
    this.getListRequestsEvaluated(event);
    this.reportsComponent.messageError = '';
  }
}
